import React from 'react';

import * as styles from './index.module.scss';

const PlayIcon = ({title = 'Play icon', hover = false}) => (
    <svg 
        className={styles.playIcon}
        title={`${title}`}
        version="1.1" 
        id="Layer_1" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlnsXlink="http://www.w3.org/1999/xlink" 
        x="0px" 
        y="0px" 
        viewBox="0 0 200 200" 
        xmlSpace="preserve"
    >
        <g>
            <path className={(hover) ? styles.playIconShape + ' ' + styles.playIconShapeActive : styles.playIconShape} d="M191.9,9.2C182,6.7,156.6,2.6,100,2.6S18,6.7,8.1,9.2c-3.3,0.7-5.5,3.7-5.5,6.9v167.8c0,3.3,2.3,6.2,5.5,6.9
                c9.9,2.4,35.3,6.5,91.9,6.5s82-4.1,91.9-6.5c3.3-0.7,5.5-3.7,5.5-6.9V16.1C197.4,12.7,195,9.9,191.9,9.2z"
            />
        </g>
        <g>
            <path className={styles.playIconOutline} d="M100,200c-57,0-82.4-4.1-92.5-6.6c-4.3-1-7.5-5-7.5-9.5V16.1c0-4.5,3.2-8.5,7.5-9.5C17.6,4.1,43,0,100,0
                c57,0,82.4,4.1,92.5,6.6c4.4,1,7.5,4.9,7.5,9.5v167.8c0,4.5-3.2,8.5-7.5,9.5C182.4,195.9,157,200,100,200z M100,5.3
                c-56.5,0-81.4,4-91.3,6.5c-2,0.5-3.5,2.3-3.5,4.4v167.8c0,2,1.5,3.9,3.4,4.4c9.9,2.4,34.8,6.5,91.3,6.5c56.5,0,81.4-4,91.3-6.4
                c2-0.5,3.5-2.3,3.5-4.4V16.1c0-2.1-1.4-3.9-3.4-4.4l0,0C181.4,9.3,156.5,5.3,100,5.3z"
            />
        </g>
        <path className={(hover) ? styles.playIconPlay + ' ' + styles.playIconPlayActive : styles.playIconPlay} d="M70.6,155.4c-1.6,0-3.2-0.4-4.7-1.2c-3.2-1.7-5.2-5.1-5.2-8.7v-91c0-3.6,2-6.9,5.2-8.7c3.2-1.7,6.9-1.6,10,0.3
            l71.6,45.6c2.8,1.8,4.5,4.9,4.5,8.3c0,3.4-1.7,6.5-4.5,8.3l-71.6,45.6C74.2,154.8,72.4,155.4,70.6,155.4z M70.6,49.8
            c-0.7,0-1.5,0.2-2.2,0.6c-1.5,0.8-2.4,2.3-2.4,4v91c0,1.7,0.9,3.2,2.4,4c1.5,0.8,3.2,0.8,4.6-0.1l71.6-45.6c1.3-0.9,2.1-2.2,2.1-3.8
            c0-1.6-0.8-3-2.1-3.8L73,50.5C72.3,50.1,71.4,49.8,70.6,49.8z"
        />
    </svg>
);

export default PlayIcon;